<template>
  <Modal class="newsModal" :title="title" :isOpen="isOpen" @close="close()" @callbackBtn1="close()" :buttons="{
    column: true,
    data: [
      {
        label: 'J\'ai compris',
        class: 'primary',
      },
    ],
  }">
    <template #icon>
      <img src="@/assets/images/img/rocket.png" alt="icon" class="icon" />
    </template>
    <template #extra>
      <div class="text" v-html="text" />
      <div class="dontShowAgain">
        <input type="checkbox" id="dontShowAgain" v-model="dontShowAgain" />
        <label for="dontShowAgain" class="ml-2">
          Ne plus afficher cette fenêtre
        </label>
      </div>
    </template>
  </Modal>
</template>

<style lang="scss" scoped>
.newsModal {
  line-height: normal;

  :deep(.modal-body) {
    @media screen and (max-width: 767px) {
      padding-bottom: 16px !important;
    }
  }

  .icon {
    margin: 0 auto;

    width: 88px;
    height: 88px;
  }

  :deep(h2) {
    max-width: 100% !important;
    margin: 32px 0 !important;

    text-align: center;
    font-size: 26px;
    line-height: normal;
  }

  .dontShowAgain {
    display: flex;
    margin-top: 32px;

    input {
      margin-right: 8px;
    }
  }
}
</style>

<script setup>
import { ref } from "vue";

defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
  },
  text: {
    type: String,
  },
});

const emits = defineEmits(["close"]);

const dontShowAgain = ref(false);

function close() {
  // Pass the dontShowAgain value when closing
  emits("close", dontShowAgain.value);
}
</script>